import { BRAND } from "@/lib/constants";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="text-white"
      style={{ backgroundColor: "#5C5654" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={BRAND.logo}
              alt="FS Mountain Skills"
              className="h-14 w-14 object-cover rounded-md"
            />
            <div
              className="text-xl font-semibold"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              FS Mountain Skills
            </div>
          </div>
          <p className="mt-6 max-w-sm text-white/70 leading-relaxed">
            Climbing instruction, group abseils and private guiding across the
            Lake District and Lancashire — delivered by qualified, local
            instructors.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.22em] uppercase text-[#3FB6B2] font-semibold mb-4">
            Explore
          </div>
          <ul className="space-y-3 text-white/85">
            <li><a href="#services" className="hover:text-white">Services</a></li>
            <li><a href="#about" className="hover:text-white">About</a></li>
            <li><a href="#gallery" className="hover:text-white">Gallery</a></li>
            <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            <li><a href="#book" className="hover:text-white">Book a session</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs tracking-[0.22em] uppercase text-[#3FB6B2] font-semibold mb-4">
            Get in touch
          </div>
          <ul className="space-y-3 text-white/85">
            <li className="flex items-center gap-2">
              <Mail size={14} /> <a href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={14} /> <a href={`tel:${BRAND.phone}`} className="hover:text-white">{BRAND.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin size={14} /> Lancashire · Lake District
            </li>
          </ul>

          <div className="mt-6 flex items-center gap-3">
            <a
              href="#"
              aria-label="Instagram"
              className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-white/10 transition-colors"
              data-testid="social-instagram"
            >
              <Instagram size={16} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-white/10 transition-colors"
              data-testid="social-facebook"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <div>© {new Date().getFullYear()} FS Mountain Skills. All rights reserved.</div>
          <div className="tracking-[0.22em] uppercase">Climb safe · climb local</div>
        </div>
      </div>
    </footer>
  );
}
